import { useQuery } from "@tanstack/react-query";
import { myAxiosAdmin } from "../../../utils/common";
import { useEffect, useState } from "react";
import clsx from "clsx";
import AssignedModules from "./AssignedModules";
import AssignModuleBox from "./AssignModuleBox";
import { adminCohortAssignedModules } from "../queries";
import ContentsToAssign from "./ContentsToAssign";
import { IAssignedModule } from "../../../types/generalTypes";

interface ICohort {
  id: number;
  name: string;
  education_type: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export default function AssignMain() {
  const [pickedCohorts, setPickedCohorts] = useState<ICohort[]>([]);
  const [openedModule, setOpenedModule] = useState<undefined | IAssignedModule>(
    undefined
  );
  const [shouldFetch, setShouldFetch] = useState(false);

  useEffect(() => {
    setShouldFetch(false);
  }, [openedModule?.module_id]);

  const { data: allCohorts } = useQuery({
    queryFn: async (): Promise<ICohort[]> =>
      myAxiosAdmin.get("/cohort/").then((r) => r.data),
    queryKey: ["allCohorts"],
  });

  function handleCohortClick(c: ICohort) {
    setPickedCohorts((prev) =>
      prev.find((p) => p.id === c.id)
        ? [...prev.filter((p) => p.id !== c.id)]
        : [...prev, c]
    );
  }

  const cohort_ids = pickedCohorts.map((c) => c.id);
  const { data: assignedModules, isSuccess } = useQuery(
    adminCohortAssignedModules({
      cohort_ids: cohort_ids.sort((a, b) => a - b),
    })
  );

  return (
    <div className="h-full flex">
      <div className="flex-1 max-w-xs panel p-8 text-sm">
        <div>
          <h2 className="p-1 uppercase font-semibold text-myOrange">
            Active Cohorts
          </h2>
          <div className="flex flex-col gap-1 border border-white/15 rounded-xl p-1">
            {allCohorts?.map((c) => (
              <div
                key={c.id}
                onClick={() => handleCohortClick(c)}
                className={clsx(
                  "px-3 py-2 cursor-pointer rounded-lg",
                  pickedCohorts.find((p) => p.id === c.id)
                    ? "text-myGreen"
                    : "hover:bg-myGreen/20"
                )}
              >
                {c.name} ({c.education_type}, #{c.id})
              </div>
            ))}
          </div>
        </div>
      </div>

      {/*
        sprint order, sprint name, assign date, mc_id, içeriği göster butonu
      */}

      {pickedCohorts.length === 0 && (
        <div className="p-4">Önce listeden cohort seç</div>
      )}

      {pickedCohorts.length > 0 && (
        <div className="flex-1 px-12 py-10 border-white/20 border-r overflow-auto">
          <div className="panel rounded-3xl border border-myGb/40">
            {isSuccess ? (
              <>
                <AssignModuleBox cohortIds={pickedCohorts.map((c) => c.id)} />
                <AssignedModules
                  modules={assignedModules || []}
                  openedModule={openedModule}
                  setOpenedModule={setOpenedModule}
                  setShouldFetch={setShouldFetch}
                />
              </>
            ) : (
              <div className="p-6">yükleniyor...</div>
            )}
          </div>
        </div>
      )}
      <div className="flex-1 px-12 py-10">
        <ContentsToAssign openedModule={openedModule} shouldFetch={shouldFetch} />
      </div>
    </div>
  );
}
